<template lang="pug">
  .img-cropper(
    v-show="cropper"
    :class="{'img-cropper_hidden': hideCropper}"
  )
    .img-cropper__container
      .img-cropper__original
        .img-cropper__title Оригинал
        .img-cropper__original-img
          img(ref="source" :src="objectUrl")
        .img-cropper__controls
          .img-cropper__controls-group
            button.link.link_inherit(
              type="button"
              @click="resetCropper"
            )
              icon(icon-name="expand")
          .img-cropper__controls-group
            button.link.link_inherit(
              type="button"
              @click="rotateLeft"
            )
              icon(icon-name="rotate-left")
            button.link.link_inherit(
              type="button"
              @click="rotateRight"
            )
              icon(icon-name="rotate-right")
      .img-cropper__preview
        .img-cropper__title Предпросмотр
        slot(name="preview")
</template>

<script>
import Cropper from 'cropperjs'
import debounce from 'lodash/debounce'

export default {
  name: 'Cropper',
  props: {
    img: String,
    hideCropper: Boolean
  },
  data () {
    return {
      cropper: null,
      objectUrl: null,
      previewCropped: null,
      selectedFile: null,
      debouncedUpdatePreview: debounce(this.updatePreview, 257)
    }
  },
  methods: {
    resetCropper () {
      this.cropper.reset()
    },
    rotateLeft () {
      this.cropper.rotate(-90)
    },
    rotateRight () {
      this.cropper.rotate(90)
    },
    setupCropper (e, img) {
      if (this.cropper) {
        this.cropper.destroy()
      }

      if (this.objectUrl) {
        window.URL.revokeObjectURL(this.objectUrl)
      }

      if (img) {
        this.objectUrl = img
        this.$nextTick(this.setupCropperInstance)
        return
      }

      const selectedFile = e && e.target.files[0]

      if (!selectedFile) {
        this.cropper = null
        this.objectUrl = null
        this.previewCropped = null
        this.$emit('change', null)
        return
      }

      this.objectUrl = window.URL.createObjectURL(selectedFile)
      this.$nextTick(this.setupCropperInstance)
    },
    setupCropperInstance () {
      const size = window.innerWidth < 768 ? 240 : 150
      this.cropper = new Cropper(this.$refs.source, {
        aspectRatio: 1,
        autoCropArea: 1,
        minContainerHeight: size,
        minContainerWidth: size,
        minCropBoxHeight: 50,
        minCropBoxWidth: 50,
        crop: this.debouncedUpdatePreview
      })
    },
    updatePreview () {
      const canvas = this.cropper.getCroppedCanvas({
        maxWidth: 512,
        maxHeight: 512,
        fillColor: '#fff'
      })
      this.previewCropped = canvas.toDataURL('image/png')
      this.$emit('change', this.previewCropped)
    }
  },
  mounted () {
    if (this.img) {
      this.setupCropper(false, this.img)
    }
  }
}
</script>

<style lang="scss" scoped>
  .img-cropper {
    background-color: $bg-light;
    border-radius: $border-radius;

    &_hidden {
      height: 0;
      position: relative;
      overflow: hidden;
      opacity: 0;
    }

    &__container {
      align-items: flex-start;
      padding: 20px 24px;
      text-align: center;

      @media (min-width: breakpoint(md)) {
        display: flex;
      }
    }

    &__title {
      font-weight: $font-weight-semibold;
      @include text-xs;
      margin-bottom: 4px;
    }

    &__original {
      flex: 0 0 auto;
      margin-bottom: 16px;

      @media (min-width: breakpoint(md)) {
        margin: 0 34px 0 0;
      }
    }

    &__original-img {
      background-color: $color-white;
      border: 1px solid map_get($color-neutral-black, 15);
      width: 240px;
      height: 240px;
      position: relative;
      margin: 0 auto;

      @media (min-width: breakpoint(md)) {
        width: 150px;
        height: 150px;
      }
    }

    &__controls {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 96px;
      margin: 4px auto 0;

      button {
        padding: 5px;
        margin: 0 2px;

        &:focus {
          opacity: 0.5;
        }

        .svg-icon {
          display: block;
          width: 14px;
          height: 14px;
        }
      }
    }

    &__controls-group {
      flex: 0 0 auto;
      margin: 0 -2px;
    }

    &__preview {
      flex: 1 1 100%;
    }
  }
</style>

<style lang="scss">
  @import '~cropperjs/dist/cropper.css';

  .cropper-view-box {
    outline: 1px solid $color-primary;
  }

  .cropper-point {
    background-color: $color-primary;
    opacity: 1;
  }

  .cropper-line {
    opacity: 0;
  }
</style>
